"use client";

import { ListingGalleryPhotosOnRequest } from "@/components/listings/gallery/listing-gallery-photos-on-request";
import type { DetailedListing } from "@/lib/types";
import { buildBusinessTypeImageCDNAssetUrl } from "@/lib/url";
import { buildImageCDNUrl } from "@repo/image-transformations";

export function ListingGalleryFallback({
  listing,
}: {
  listing: DetailedListing;
}) {
  if (!listing.businessType) {
    return null;
  }

  const imageUrl = buildImageCDNUrl(
    buildBusinessTypeImageCDNAssetUrl(listing.businessType.slug),
    "large",
  );

  return (
    <div className="relative rounded-md overflow-hidden col-span-3 row-span-3">
      <img
        src={imageUrl}
        alt={listing.businessType.name}
        className="w-full h-[200px] object-cover"
      />

      <ListingGalleryPhotosOnRequest listing={listing} />
    </div>
  );
}
